import React from "react";
import "./With_Dep_Ammout_card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightArrowLeft, faWallet } from "@fortawesome/free-solid-svg-icons";

function With_Dep_Ammout_card() {
  return (
    <>
      <section className="With_Dep_Ammout_card">
        <div className="bg_holder_holder">
          <div className="bg_img">
            <img
              src="/assets/images/withdraw_Deposite/With_Dep_Ammout_card/bg.png"
              alt="card background"
              className="card_background_img"
            />

            <div className="card_content">
              <div className="balance_top">
                <span className="balance_icon"><FontAwesomeIcon icon={faWallet} /></span>
                <span>Available balance</span>
              </div>

              <div className="balance_amount">
                ₹ 238.89
                <span className="refresh_icon"><FontAwesomeIcon icon={faArrowRightArrowLeft} /></span>
              </div>

              <div className="card_dots">**** &nbsp;&nbsp; ****</div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default With_Dep_Ammout_card;
